import { ReactElement } from 'react';
import { Button } from '@appsumo/dorado-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

export default function AddButton({
  label,
  onClick,
  className,
}: Readonly<{
  label: string;
  onClick: () => void;
  className?: string;
}>): ReactElement {
  return (
    <Button secondary onClick={onClick} className={className}>
      <FontAwesomeIcon icon={faPlus} height="16" className="mr-1" />
      {label}
    </Button>
  );
}
